/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Template_Position_HInputs */

const en_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H:`)
};

const fr_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H:`)
};

const de_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H:`)
};

const it_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H:`)
};

const ru_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЧАС:`)
};

const es_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H:`)
};

const zh_cn2_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H：`)
};

const ja_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H:`)
};

const hi_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एच:`)
};

const pt_pt2_event_template_position_h = /** @type {(inputs: Event_Template_Position_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H:`)
};

/**
* | output |
* | --- |
* | "H:" |
*
* @param {Event_Template_Position_HInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_template_position_h = /** @type {((inputs?: Event_Template_Position_HInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Template_Position_HInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_template_position_h(inputs)
	if (locale === "de") return de_event_template_position_h(inputs)
	if (locale === "it") return it_event_template_position_h(inputs)
	if (locale === "ru") return ru_event_template_position_h(inputs)
	if (locale === "es") return es_event_template_position_h(inputs)
	if (locale === "zh-CN") return zh_cn2_event_template_position_h(inputs)
	if (locale === "ja") return ja_event_template_position_h(inputs)
	if (locale === "hi") return hi_event_template_position_h(inputs)
	if (locale === "pt-PT") return pt_pt2_event_template_position_h(inputs)
	return en_event_template_position_h(inputs)
});